'use client';

import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useContext, useEffect, useState } from 'react';

import InternalLink from '@/components/InternalLink';
import ScreenWidthContext from '@/contexts/ScreenWidthContext';
import stepperTwo from 'public/icons/round-2.svg';
import stepperThreeFilled from 'public/icons/round-3-filled.svg';
import stepperThree from 'public/icons/round-3.svg';
import stepperTick from 'public/icons/round-tick.svg';
import patynaLogo from 'public/images/patyna_logo.svg';

import styles from './styles.module.scss';

const stepperActiveClass = cn(styles.stepperItem, styles.stepperActive);

const HeaderCheckout = () => {
  const { isMobile } = useContext(ScreenWidthContext);
  const [isCheckoutMenu, setIsCheckoutMenu] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const pathname = usePathname();

  const handleScroll = () => {
    const scrolled = window.scrollY > 175;
    setIsScrolled(scrolled);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (pathname?.includes('/zamowienie') || pathname?.includes('/logowanie')) {
      setIsCheckoutMenu(true);
    } else {
      setIsCheckoutMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <nav
      className={cn(styles.nav, {
        [styles.shadow]: isScrolled && isMobile,
      })}
    >
      <div className={styles.navWrapper}>
        <div className={styles.wrapper}>
          <div
            className={cn(styles.leftCol, {
              [styles.hide]: isScrolled && isMobile,
            })}
          >
            <Link href="/">
              <Image
                className={styles.logo}
                src={patynaLogo}
                alt="Patyna - sklep z meblami i dekoracjami vintage"
                width={80}
                priority
              />
            </Link>
          </div>
          <div className={styles.stepperContainer}>
            {isMobile ? null : (
              <div className={styles.stepperItem}>
                <Image src={stepperTick} alt="Ikona" /> Twój koszyk
              </div>
            )}
            {isCheckoutMenu ? (
              <>
                {isMobile ? (
                  <>
                    <div className={styles.checkoutStepBox}>
                      <div className={styles.checkoutStepBoxUp}>
                        <Link href="/koszyk/"></Link>
                        <span>
                          <strong>2</strong>/3
                        </span>
                      </div>
                      <div className={styles.checkoutStepBoxBottom}>
                        Dostawa i płatność
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={stepperActiveClass}>
                      <Image src={stepperTwo} alt="Ikona" /> Dostawa i płatność
                    </div>
                    <div className={styles.stepperItem}>
                      <Image src={stepperThree} alt="Ikona" /> Gotowe
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                {isMobile ? (
                  <>
                    <div className={styles.checkoutStepBox}>
                      <div className={styles.checkoutStepBoxUp}>
                        <Link href="/koszyk/"></Link>
                        <span>
                          <strong>3</strong>/3
                        </span>
                      </div>
                      <div className={styles.checkoutStepBoxBottom}>Gotowe</div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles.stepperItem}>
                      <Image src={stepperTick} alt="Ikona" /> Dostawa i płatność
                    </div>
                    <div className={stepperActiveClass}>
                      <Image
                        src={stepperThreeFilled}
                        alt="Ikona"
                        width={21}
                        height={21}
                      />{' '}
                      Gotowe
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {/*
      <div className={styles.backToCart}>
        <InternalLink link="/koszyk" label="Powrót do koszyka" isLeftSideIcon />
      </div>
      */}
    </nav>
  );
};

export default HeaderCheckout;
